export default __webpack_public_path__ + "train.png?06ba461e73d97f13e669c6f81af1d922";